// src/core/config.js
export const ENV = {
  DEV: process.env.NODE_ENV === "development",
  PROD: process.env.NODE_ENV === "production",
};

export const OAUTH_CONFIG = {
  CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  REDIRECT_URI: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
  AUTH_ENDPOINT: "https://accounts.google.com/o/oauth2/v2/auth",
  TOKEN_ENDPOINT: "https://oauth2.googleapis.com/token",
  RESPONSE_TYPE: "code",
  SCOPES: [
    "openid",
    "email",
    "profile",
    "https://www.googleapis.com/auth/spreadsheets",
  ],
  ACCESS_TYPE: "offline",
  PROMPT: "consent",
};



/*export const SHEET_IDS = {
  MAIN_DB: process.env.REACT_APP_MAIN_SHEET_ID,
  SHEETS: {
    BOOKS: "Books!A2:Z",
    CLASSES: "Classes!A2:Z",
    ORDERS: "Orders!A2:Z",
    USERS: "Users!A2:Z",
  },
};*/

//console.log("Google Client ID:", OAUTH_CONFIG.CLIENT_ID);

// src/core/config.js
export const SHEET_IDS = {
  MASTER: process.env.REACT_APP_MASTER_SHEET_ID,
};

console.log('🔍 MASTER ID from env:', process.env.REACT_APP_MASTER_SHEET_ID);